import React from 'react'

import { SxProps } from '@mui/material'

import Icon, { IconProps } from 'components_new/atoms/Icon'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'
import Text from 'components_new/atoms/Text'
import Tooltip from 'components_new/atoms/Tooltip'

export type TBreadcrumbItem = {
  href?: string
  icon?: IconProps
  newTab?: boolean
  search?: string
  sx?: SxProps
  title: string
  titleIcon?: IconProps
  tooltip?: string
}

export interface BreadcrumbsProps {
  highlightCurrent?: boolean
  items: TBreadcrumbItem[]
  sx?: object
}

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { highlightCurrent, items, sx } = props

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        flexWrap: 'nowrap',
        minWidth: 0,
        position: 'relative',
        ...sx
      }}
    >
      {items.map((item, i) => {
        return (
          <React.Fragment key={`${item.title}-${i}`}>
            <Tooltip title={item.tooltip}>
              <Chip
                clickable={Boolean(item.href) || Boolean(item.search)}
                color="transparent"
                deleteIcon={
                  item.titleIcon ? <Icon {...item.titleIcon} /> : <></>
                }
                onDelete={() => {}}
                href={item.href}
                icon={
                  item.icon ? (
                    <Icon className="ChipIcon" name={item.icon.name} />
                  ) : undefined
                }
                label={item.title}
                newTab={item.newTab}
                search={item.search}
                size="small"
                sx={{
                  ...(highlightCurrent && i !== items.length - 1
                    ? {
                        [':not(:hover)']: {
                          color: 'text.disabled',
                          ['& .ChipIcon']: {
                            color: 'text.disabled'
                          }
                        },
                        ...(!item.href
                          ? {
                              [':hover']: {
                                color: 'text.disabled',
                                ['& .ChipIcon']: {
                                  color: 'text.disabled'
                                }
                              }
                            }
                          : null)
                      }
                    : null),
                  minWidth: 0,
                  ...item.sx,
                  ['& .MuiChip-deleteIcon']: {
                    ['&:hover']: {
                      color: 'action.disabled'
                    }
                  }
                }}
              />
            </Tooltip>
            {i !== items.length - 1 ? (
              <Text
                color="text.secondary"
                component="span"
                lineHeight={1}
                sx={{ mx: '0.25em' }}
              >
                /
              </Text>
            ) : null}
          </React.Fragment>
        )
      })}
    </Box>
  )
}

export default Breadcrumbs
